export enum LegalIdentifierStatus {
	None = 'None',
	Success = 'Success',
	Failure = 'Failure',
}
